import { UrlTargetEnumTarget } from '@wix/ambassador-forms-v4-form/types';
export const redirectToExternalUrl = redirectOptions => {
  var _redirectOptions$redi;
  const urlWithoutProtocol = redirectOptions == null || (_redirectOptions$redi = redirectOptions.redirectUrl) == null ? void 0 : _redirectOptions$redi.replace(/^https?:\/\//, '');
  const updatedExternalUrl = `https://${urlWithoutProtocol}`;
  window.open(updatedExternalUrl, (redirectOptions == null ? void 0 : redirectOptions.target) === UrlTargetEnumTarget.SELF ? '_self' : '_blank');
};
export const isValidUrl = url => {
  const urlPattern = new RegExp(/^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/g);
  return urlPattern.test(url);
};
export const getErrorCode = error => {
  var _error$response, _error$response2;
  return (error == null || (_error$response = error.response) == null || (_error$response = _error$response.data) == null || (_error$response = _error$response.details) == null || (_error$response = _error$response.applicationError) == null ? void 0 : _error$response.code) || (error == null ? void 0 : error.code) && String(error == null ? void 0 : error.code) || (error == null || (_error$response2 = error.response) == null || (_error$response2 = _error$response2.data) == null || (_error$response2 = _error$response2.details) == null || (_error$response2 = _error$response2.validationError) == null || (_error$response2 = _error$response2.fieldViolations) == null || (_error$response2 = _error$response2[0]) == null || (_error$response2 = _error$response2.data) == null || (_error$response2 = _error$response2.errors) == null || (_error$response2 = _error$response2[0]) == null ? void 0 : _error$response2.errorType) || 'UNKNOWN';
};
export const getErrorList = error => {
  var _error$response3;
  return error == null || (_error$response3 = error.response) == null || (_error$response3 = _error$response3.data) == null || (_error$response3 = _error$response3.details) == null || (_error$response3 = _error$response3.validationError) == null || (_error$response3 = _error$response3.fieldViolations) == null ? void 0 : _error$response3[0].data.errors;
};
export const getFormCustomErrorMessage = errors => {
  var _errors$filter;
  return errors == null || (_errors$filter = errors.filter(error => error.useCustomErrorMessage && !error.errorPath)) == null || (_errors$filter = _errors$filter[0]) == null ? void 0 : _errors$filter.errorMessage;
};
export const getFieldCustomErrorMessages = errors => errors == null ? void 0 : errors.filter(error => error.useCustomErrorMessage && error.errorPath);
export const getCheckoutMessage = text => {
  return {
    nodes: [{
      id: 'ymnqxbmks',
      type: 'PARAGRAPH',
      paragraphData: {
        textStyle: {
          textAlignment: 'CENTER'
        }
      },
      nodes: [{
        nodes: [],
        id: '',
        type: 'TEXT',
        textData: {
          text,
          decorations: []
        }
      }]
    }],
    metadata: {
      version: 1,
      id: 'af4951a2-dd8f-44ec-b2dc-cb4c09f65ee9'
    }
  };
};
//# sourceMappingURL=utils.js.map